import React, { PureComponent } from "react";

interface ISVGErase2IconProps {
  className?: string;
  size?: string | number;
  fill?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGErase2Icon extends PureComponent<
  ISVGErase2IconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 45}
        fill="#fff"           // ← 이거 고정!
        style={style}
        width="32"
        height="32"
        viewBox="0 0 40 40"
      >
        <path 
          fill="none"
          stroke="#8694B1"
          d="M38.752,21.954a3.736,3.736,0,0,0,0-5.283L26.3,4.219a3.736,3.736,0,0,0-5.283,0L1.094,24.142a3.736,3.736,0,0,0,0,5.283L8.565,36.9a3.736,3.736,0,0,0,2.642,1.094H38.913a.934.934,0,0,0,.934-.934V33.944a.934.934,0,0,0-.934-.934H27.7ZM15.2,17.08,25.891,27.771,20.653,33.01h-8.93L5.5,26.784l9.7-9.7Z" 
          transform="translate(0 -3.125)" 
          />
      </svg>
    );
  }
}
